import { render, staticRenderFns } from "./ReadRecords.vue?vue&type=template&id=54ab359a&scoped=true&"
import script from "./ReadRecords.vue?vue&type=script&lang=js&"
export * from "./ReadRecords.vue?vue&type=script&lang=js&"
import style0 from "./ReadRecords.vue?vue&type=style&index=0&id=54ab359a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab359a",
  null
  
)

export default component.exports